import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DataColumn } from '../../models';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { SharedService } from '../services/shared.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.scss',
})
export class DataTableComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  /**
   * The data source to display in the table.
   * @type {any[]}
   * @memberof DataTableComponent
   */
  @Input() dataSource: any[] = [];

  /**
   * The columns object to display in the table.
   * Each column object contains header and field properties.
   * @param header is used to display the column name,
   * @param fieldName is used to display data
   * @param dataType is used check cell type
   * @param component is used to display custom cell as compoent
   * @param cellWidth is used to set cell width in px
   * @type {{ header: string, fieldName: string,dataType:string,component:any,cellWidth:string }[]}
   * @memberof DataTableComponent
   */
  @Input() columns: DataColumn[] = [];

  /**
   * Emits the data row associated with the clicked button when a row is clicked to theparent component
   * @type {EventEmitter<any>}
   * @memberof DataTableComponent
   */

  /**
   * toogle display actions button
   * @type {boolean}
   * @memberof DataTableComponent
   */
  @Input() showActions: boolean = false;
  @Input() component: any;
  dataClicked: any;
  @Input() showSideBar: boolean = false;
  @Input() hasSideBar: boolean = true;
  @Output() onRowClick = new EventEmitter<any>();
  @Output() onFullRowClick = new EventEmitter<any>();
  @Input() hasRowAction: boolean = false;
  @Input() isLoading: boolean = false;
  @Output() rowActionClick = new EventEmitter<any>();
  @Output() nextPage = new EventEmitter<any>();

  @Input() pageSize = 10;
  @Input() totalItems = 0;
  @Input() pageIndex = 0;
  constructor(
    private injector: Injector,
    public _MatPaginatorIntl: MatPaginatorIntl,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this._MatPaginatorIntl.itemsPerPageLabel = 'your custom text 1';
    this._MatPaginatorIntl.firstPageLabel = 'Première page';
    this._MatPaginatorIntl.itemsPerPageLabel = "Nombre d'éléments par page";
    this._MatPaginatorIntl.lastPageLabel = 'Dernière page';
    this._MatPaginatorIntl.nextPageLabel = 'Suivant';
    this._MatPaginatorIntl.previousPageLabel = 'Retour';
    this._MatPaginatorIntl.getRangeLabel(1, 10, 100);
  }
  // /**
  //  * Handles internally the click event when a row is clicked.
  //  * @param {any} row The data row associated with the clicked row.
  //  * @memberof DataTableComponent
  //  */
  handleRowClick(row: any, actionName: string) {
    (this.sharedService as any)[actionName](row);
  }
  // handleFullRowClick(row: any) {
  //   this.onFullRowClick.emit(row);
  // }

  rowClicked(row: any) {
    this.onFullRowClick.emit(row);
    // this.dataClicked = row
    // this.showSideBar = !this.showSideBar
  }
  dynamicComponentInjector(): Injector {
    return this.injector;
  }
  returnToFirstPage(event?: any) {
    this.paginator.firstPage();
  }
}
